import React from "react";
import TollFreeServices from "../Common/TollFreeServices";
import TollFreeBanner from "../PageBanners/TollFreeBanner";
import Footer from "../Common/Footer";

class TollFreeServicesPage extends React.Component {
  render() {
    return (
      <>
        <TollFreeBanner />
        <TollFreeServices />
        <Footer />
      </>
    );
  }
}

export default TollFreeServicesPage;
